import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';

const PrivateRoute = ({ element, ...rest }) => {
    const navigate = useNavigate();
    const { isAuthenticated, setAuth } = useContext(AuthContext);
    const location = useLocation();
    useEffect(() => {   
        const oData = localStorage.getItem('userInfo');        
        if (JSON.parse(oData)) {
            setAuth(JSON.parse(oData));
            navigate(location.pathname);
        }else {
            navigate("/login");
        }
    }, [setAuth]); 

    return isAuthenticated ? element : <Navigate to="/login" state={{ from: location }} />;
};

export default PrivateRoute;
